// extracted by mini-css-extract-plugin
module.exports = {"Root":"Plugin_Root__2UT-C","ItemsContentPanel":"Plugin_ItemsContentPanel__383c-"};